import css from "./mdr-section.module.scss";

/**
 * The tile's blue field, rebuilt from the client's mockup as gradient and vector
 * rather than carried as an image: it costs nothing to ship, stays sharp at any
 * width, and one artwork serves the tall phone layout and the wide desktop one.
 *
 * Each ornament is anchored to the corner it belongs to rather than laid out on
 * one cover-scaled canvas. The mockup is drawn 3:2, and the tile is nearly twice
 * as tall as that on a phone; a single `slice` canvas answers that by sliding the
 * diagonals into the middle of the form, where they read as scratches. Anchored,
 * the bands stay in the top-right corner and the petal in the bottom-left at
 * every width, which is what the drawing means.
 *
 * Proportions are the mockup's own, measured in its 1536x1024 space: the bands
 * sit 10.5% and 5.3% in from the right edge at 7.2% and 5.2% wide, and lean
 * 0.41 across for every 1 down.
 */
export const MdrBackdrop = () => (
  <>
    <div className={css["backdrop"]} aria-hidden="true" />
    <span className={css["bands"]} aria-hidden="true" />
    <svg
      className={css["petal"]}
      viewBox="0 0 563 238"
      preserveAspectRatio="xMinYMax meet"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* Straight edge up to the apex, then the long curve back out through the
          bottom-left. The control point sits above the box on purpose. */}
      <path
        d="M406 238 L563 0 Q241 -29 0 238"
        stroke="#fff"
        strokeOpacity="0.34"
        strokeWidth="2.5"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  </>
);
